import React from "react";
import {useTranslation} from "react-i18next";
import {useContext} from "react";
import {Context} from "../../context/DependSearchContext";


function DependSearchInput() {
    const {t} = useTranslation();
    const ctx = useContext(Context);

    const changeHandler = (evt) => {
        if (evt.target.value.trim().length >= 2 || evt.target.value.trim() === "") {
            ctx.setState(evt.target.value.trim())
        }else {
            ctx.setState("");
        }
    }

    return (
        <div className="w-[15%]">
            <input
                placeholder={t('action.search')}
                type="text"
                autoComplete="address-level2"
                onChange={changeHandler}
                className="mt-1 w-full block rounded-md border-gray-500 py-1 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
        </div>
    );
}

export default DependSearchInput;
